"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListBase = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var EqualityComparers_1 = require("icf-search-client-shared/lib/EqualityComparers");
var Geometry_1 = require("icf-search-client-shared/lib/Geometry");
var ComputedObservable_1 = require("icf-search-client-shared/lib/observables/ComputedObservable");
var Profiler_1 = require("icf-search-client-shared/lib/Profiler");
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var Ioc_1 = require("../../utilities/Ioc");
var VisibleItemsContext_1 = require("./VisibleItemsContext");
var ListBase = /** @class */ (function (_super) {
    __extends(ListBase, _super);
    function ListBase(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._isMounted = false;
        _this._visibleItemsContext = new VisibleItemsContext_1.VisibleItemsContext();
        return _this;
    }
    Object.defineProperty(ListBase.prototype, "viewport", {
        get: function () {
            return this._viewport;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "isMounted", {
        get: function () {
            return this._isMounted;
        },
        enumerable: false,
        configurable: true
    });
    ListBase.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.dataSource !== this.props.dataSource || prevProps.layoutOptions !== this.props.layoutOptions) {
            this._attachDataSource();
            this.forceUpdate();
        }
    };
    ListBase.prototype.componentDidMount = function () {
        var _this = this;
        this._layoutSite = this.createLayoutSite();
        this._viewport = this.createViewport();
        this._attachDataSource();
        if (this.props.autoRefreshIntervalMs) {
            this._refreshIntervalHandle = (0, Utilities_1.createInterval)(function () {
                var _a;
                // No good way to test this without completely tearing down and starting up JSDom.
                /* istanbul ignore next */
                if (document.visibilityState !== "visible") {
                    return;
                }
                if ((_a = _this.props.dataSource.resultsContext.value) === null || _a === void 0 ? void 0 : _a.currentError) {
                    return;
                }
                _this.forceUpdate();
            }, this.props.autoRefreshIntervalMs);
        }
        this._isMounted = true;
        this.forceUpdate();
    };
    ListBase.prototype.componentWillUnmount = function () {
        this._isMounted = false;
        if (this._refreshIntervalHandle) {
            this._refreshIntervalHandle.dispose();
        }
        this._detachDataSource();
        this._viewport.dispose();
        this._layoutSite.dispose();
    };
    Object.defineProperty(ListBase.prototype, "currentLayoutPassContext", {
        get: function () {
            return this._currentLayoutPassContext;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ListBase.prototype, "layoutSite", {
        get: function () {
            return this._layoutSite;
        },
        enumerable: false,
        configurable: true
    });
    ListBase.prototype._createLayoutPassContext = function () {
        this._currentLayoutPassContext = this.props.layout.createLayoutPassContext(this.props.layoutOptions, this._layoutSite.availableSize.value, this.props.dataSource.itemCount.value);
    };
    ListBase.prototype._updateVisibleItemsContext = function () {
        var _a, _b;
        // TODO: Is defaulting to 0..0 valid or should we throw?
        this._visibleItemsContext.update(this.props.dataSource, (_b = (_a = this._visibleItemRange) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : { start: 0, end: 0 });
    };
    ListBase.prototype._attachDataSource = function () {
        var _this = this;
        this._detachDataSource();
        this._createLayoutPassContext();
        this._resultsContextChangedSubscription = this.props.dataSource.resultsContext.subscribe(function () {
            _this._updateVisibleItemsContext();
        });
        this._availableSizeChangedSubscription = this._layoutSite.availableSize.subscribe(function () {
            _this._createLayoutPassContext();
            _this.forceUpdate();
        });
        this._visibleItemRange = new ComputedObservable_1.ComputedObservable(function () {
            return _this._calculateVisibleItemRange();
        }, [
            this._viewport.visibleRect,
            this.props.dataSource.totalItemCount,
            this.props.dataSource.itemsChanged,
            this._layoutSite.availableSize,
        ], EqualityComparers_1.rangeEqualityComparer);
        this._overscanVisibleItemRange = new ComputedObservable_1.ComputedObservable(function () {
            return _this._calculateVisibleItemRange(true);
        }, [this._visibleItemRange], EqualityComparers_1.rangeEqualityComparer);
        this._itemCountSubscription = this.props.dataSource.itemCount.subscribe(function () {
            _this._createLayoutPassContext();
        });
        this._visibleItemRangeSubscription = this._visibleItemRange.subscribe(function () {
            _this._updateVisibleItemsContext();
        });
        this._overscanVisibleItemRangeSubscription = this._overscanVisibleItemRange.subscribe(function () {
            _this.forceUpdate();
        });
        this._itemsChangedSubscription = this.props.dataSource.itemsChanged.subscribe(function () {
            _this._createLayoutPassContext();
            _this.forceUpdate();
        });
        this._updateVisibleItemsContext();
    };
    ListBase.prototype.forceUpdate = function (cb) {
        var _this = this;
        Profiler_1.profiler.measure(function () {
            _super.prototype.forceUpdate.call(_this, cb);
        }, "ListBase.forceUpdate");
    };
    ListBase.prototype._detachDataSource = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (_a = this._overscanVisibleItemRangeSubscription) === null || _a === void 0 ? void 0 : _a.dispose();
        (_b = this._visibleItemRangeSubscription) === null || _b === void 0 ? void 0 : _b.dispose();
        (_c = this._availableSizeChangedSubscription) === null || _c === void 0 ? void 0 : _c.dispose();
        (_d = this._itemsChangedSubscription) === null || _d === void 0 ? void 0 : _d.dispose();
        (_e = this._visibleItemRange) === null || _e === void 0 ? void 0 : _e.dispose();
        (_f = this._overscanVisibleItemRange) === null || _f === void 0 ? void 0 : _f.dispose();
        (_g = this._resultsContextChangedSubscription) === null || _g === void 0 ? void 0 : _g.dispose();
        (_h = this._itemCountSubscription) === null || _h === void 0 ? void 0 : _h.dispose();
        (_j = this._overscanVisibleItemRangeSubscription) === null || _j === void 0 ? void 0 : _j.dispose();
        this._currentLayoutPassContext = undefined;
    };
    ListBase.prototype._calculateVisibleItemRange = function (withOverscan) {
        if (withOverscan === void 0) { withOverscan = false; }
        // TODO: Throw if this is called without being mounted?
        var layoutContext = this.currentLayoutPassContext;
        var viewportOverscan = this.props.viewportOverscan;
        // The visible rect from the viewport is expanded for the visual overscan.
        var visibleRect = withOverscan && viewportOverscan
            ? (0, Geometry_1.expandRect)(this._viewport.visibleRect.value, viewportOverscan)
            : this._viewport.visibleRect.value;
        // Here, we ask the layout for visible range of items to render within the layout site based on the available
        // space and the intersecting visible bounds. The layout is provided
        var visibleItemRange = this.props.layout.getItemRangeForRect(layoutContext, visibleRect);
        // Now, we clamp that range to the item range we want to display at most. This way, even with loading overscan,
        // we won't load or render items outside of the specified range.
        var clampedItemRange = {
            start: Math.max(0, visibleItemRange.start),
            end: Math.min(visibleItemRange.end, this.props.dataSource.itemRange.value.end - this.props.dataSource.itemRange.value.start),
        };
        return clampedItemRange;
    };
    ListBase.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Ioc_1.ContextProvider, { contexts: [[VisibleItemsContext_1.IVisibleItemsContextContext, this._visibleItemsContext]], children: this.renderList() }));
    };
    ListBase.prototype.getFullContentSize = function () {
        if (!this._currentLayoutPassContext) {
            return { width: 0, height: 0 };
        }
        return this.props.layout.getFullContentSize(this._currentLayoutPassContext);
    };
    ListBase.prototype.createItemContainers = function () {
        var itemRange, itemIterator, itemIndex, item;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // TODO: Throw if mounted without item range?
                    if (!this._isMounted || !this._overscanVisibleItemRange) {
                        return [2 /*return*/];
                    }
                    itemRange = this._overscanVisibleItemRange.value;
                    itemIterator = this.props.dataSource.getItemsInRange(itemRange);
                    itemIndex = itemRange.start;
                    item = itemIterator.next();
                    _a.label = 1;
                case 1:
                    if (!!item.done) return [3 /*break*/, 3];
                    return [4 /*yield*/, Profiler_1.profiler.measure(function () { return _this.createItemContainer(item.value, itemIndex); }, "ListBase.createItemContainer")];
                case 2:
                    _a.sent();
                    item = itemIterator.next();
                    itemIndex++;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    };
    return ListBase;
}(React.Component));
exports.ListBase = ListBase;
//# sourceMappingURL=ListBase.js.map